import { getUserOrganisations } from "@/lib/utils";

export default {
  data() {
    return {
      declining: false,
      accepting: false
    };
  },
  computed: {
    invites() {
      return this.$store.getters.invites;
    }
  },
  methods: {
    inviteAction(id, action) {
      action === "accept" ? (this.accepting = true) : (this.declining = true);

      this.$http
        .post(`organisations/${id}/invite/${action}`, {
          method: "PUT"
        })
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            this.notification(
              `${action === "accept" ? "Accepted" : "Declined"}`,
              `Invitation ${
                action === "accept" ? "accepted" : "declined"
              } successfully.`,
              "success"
            );
            this.getOrganisations();
            this.declining = false;
            this.accepting = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.declining = false;
          this.accepting = false;
        });
    },
    getOrganisations() {
      getUserOrganisations(this.$http)
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  }
};
